import { render, staticRenderFns } from "./recoverRetrieveReportInitAction.vue?vue&type=template&id=31a4804e&scoped=true"
import script from "./recoverRetrieveReportInitAction.vue?vue&type=script&lang=js"
export * from "./recoverRetrieveReportInitAction.vue?vue&type=script&lang=js"
import style0 from "./recoverRetrieveReportInitAction.vue?vue&type=style&index=0&id=31a4804e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a4804e",
  null
  
)

export default component.exports